import { MobileAppStateContext } from 'lib/contexts/MobileAppState';
import { useContext } from 'react';

export const useMobileAppState = () => {
  return useContext(MobileAppStateContext);
};
